import React, { useEffect, useState } from 'react';
import HomeInternet from '@vds/icons/home-internet';
import WifiWireless from '@vds/icons/wifi-wireless';
import PlanSpeedUltimate from '@vds/icons/plan-speed-ultimate';
import LoaderStep from './LoaderStep';

const ProgressivePlansLoader = () => {
  const [step1Class, setStep1Class] = useState('loader-step-1 grayed');
  const [step2Class, setStep2Class] = useState('loader-step-2');
  const [step3Class, setStep3Class] = useState('loader-step-3');

  useEffect(() => {
    // Step 1 completes and Step 2 shows grayed at 2s
    const timer1 = setTimeout(() => {
      setStep1Class('loader-step-1 completed');
      setStep2Class('loader-step-2 grayed');
    }, 2000);

    // Step 2 completes and Step 3 shows grayed at 4s
    const timer2 = setTimeout(() => {
      setStep2Class('loader-step-2 completed');
      setStep3Class('loader-step-3 grayed');
    }, 4000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <div className="loader-steps-container">
      <LoaderStep
        icon={<HomeInternet />}
        text="Finding the best plans for your home"
        className={step1Class}
      />
      <LoaderStep
        icon={<WifiWireless />}
        text="Customizing your Home Internet experience"
        className={step2Class}
      />
      <LoaderStep
        icon={<PlanSpeedUltimate />}
        text="Tailoring your speed options now"
        className={step3Class}
      />
    </div>
  );
};

export default ProgressivePlansLoader;
